<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter :title="'change'">
                    <div class="text-base xs:text-lg text-green-600 font-bold mb-2.5 md:mb-4">
                        指定匯款帳號
                    </div>
                    <ResultList class="text-base xs:text-lg mb-4 md:mb-5">
                        <div class="divide-y divide-dashed text-gray-900">
                            <div class="px-2.5 md:px-5 py-2 md:py-4 flex">
                                <div class="mr-1">
                                    {{ after.bank.bankNo }}
                                </div>
                                <div>{{ after.bank.bankName }}</div>
                            </div>
                            <div class="px-2.5 md:px-5 py-2 md:py-4">
                                {{ after.bank.bankAccount }}
                            </div>
                        </div>
                    </ResultList>
                    <div class="text-base xs:text-lg text-green-600 font-bold mb-2.5 md:mb-4 pt-4 border-t border-geay-200 md:pt-0 md:border-0">
                        借款明細
                    </div>
                    <div class="border border-green-600 border-dashed rounded overflow-hidden">
                        <Table :is-border="false">
                            <template #thead>
                                <tr class="text-sm lg:text-base border-b border-green-600 border-dashed">
                                    <td>
                                        保單號碼
                                    </td>
                                    <td class="hidden md:table-cell text-center">
                                        契約狀態
                                    </td>
                                    <td class="hidden md:table-cell text-right">
                                        已借款本金
                                    </td>
                                    <td class="hidden md:table-cell text-right">
                                        借款利息
                                    </td>
                                    <td class="text-right">
                                        本月利率
                                        <div class="md:hidden">
                                            (年利率)
                                        </div>
                                    </td>
                                    <td class="hidden md:table-cell text-right">
                                        可借款金額
                                    </td>
                                    <td class="text-right">
                                        欲借款金額
                                    </td>
                                </tr>
                            </template>
                            <template #tbody>
                                <tr
                                    v-for="item in after.pon4300ResultDataList"
                                    :key="item.fullPolicyNo"
                                    class="text-base xs:text-lg md:text-base lg:text-lg text-gray-900"
                                >
                                    <td class="break-all">
                                        {{ item.fullPolicyNo }}
                                    </td>
                                    <td class="hidden md:table-cell text-center">
                                        {{ item.cnctStat }}
                                    </td>
                                    <td class="hidden md:table-cell text-right">
                                        {{ addComma(item.lastLoanPrin) }}
                                    </td>
                                    <td class="hidden md:table-cell text-right">
                                        {{ addComma(item.lastLoanInter) }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.loanRate }}%
                                    </td>
                                    <td class="hidden md:table-cell text-right">
                                        {{ addComma(item.lastLoanLimit) }}
                                    </td>
                                    <td class="text-right">
                                        {{ addComma(item.amount) }}
                                    </td>
                                </tr>
                            </template>
                        </Table>
                    </div>
                    <div class="text-lg font-medium text-gray-900 mt-2.5 md:mt-4 text-right">
                        共{{ currencyText }} {{ amountSum }}
                    </div>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, reactive, computed } from 'vue';
import { addComma } from '@/utils/number/addComma';
import { useStore } from 'vuex';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ResultList from '@/components/template/ResultList.vue';
import Table from '@/components/table/Table.vue';
import Decimal from 'decimal.js';

export default {
    name: 'Pon4300Data',
    components: {
        CollapseConfirmData,
        ResultList,
        Table
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const after = reactive(data.value.after);
        const code = ref('Pon4300');
        const store = useStore();
        const currencyText = computed(() => {
            return store.state.services.changeItemsResult[code.value]?.storeCurrentCurrency?.currencyText;
        });
        const amountSum = computed(() => {
            let sum = new Decimal(0);
            after.pon4300ResultDataList.forEach(i => {
                sum = sum.plus(i.amount);
            });
            return addComma(sum);
        });
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, data, after, addComma, amountSum, currencyText, removeService };
    },
};
</script>
<style lang="scss" scoped>
:deep(.table-base) {
    &:not(.disabled) {
        thead {
            @apply bg-none bg-green-100 text-gray-700;
        }
        tbody tr {
            @apply even:bg-white lg:text-lg text-gray-700 cursor-default lg:hover:bg-white;
        }
    }
}
</style>
